/**
 * Форматирование чисел с пробелами между тысячами
 */
export function formatNumber(value, decimals = 2) {
  if (value === null || value === undefined || value === '') {
    return '0';
  }

  const num = typeof value === 'number' ? value : parseFloat(value);

  if (isNaN(num)) {
    return '0';
  }

  // Округляем до нужного количества знаков
  const rounded = num.toFixed(decimals);

  // Разделяем на целую и дробную части
  const [integer, fraction] = rounded.split('.');

  // Добавляем пробелы между тысячами
  const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  // Если есть дробная часть и она не нули, добавляем её
  if (fraction && parseInt(fraction) !== 0) {
    return `${formattedInteger},${fraction}`;
  }

  return formattedInteger;
}

/**
 * Форматирование денег (₽)
 */
export function formatMoney(value, decimals = 2) {
  return `${formatNumber(value, decimals)} ₽`;
}

/**
 * Форматирование процентов
 */
export function formatPercent(value, decimals = 2) {
  return `${formatNumber(value, decimals)}%`;
}
